import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private router: Router,
    private storageService: StorageService,
  ) {}

  goToOffers() {
    if (this.storageService.getMobile()) {
      window.location.href = 'bedici://payment';
    } else {
      this.router.navigate(['/offers']);
    }
  }
}
